export default __webpack_public_path__ + "static/ebook-73b3c06360160e9d40567d3ba9acf105.webp";